import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  medicalPatient,
  medicalWaste,
  officeAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Các nhà sản xuất đang không ngừng nỗ lực tìm cách cải thiện vận hành nhà máy và quản lý hàng tồn kho. Những nỗ lực này được coi là nhiệm vụ quan trọng nhằm nâng cao hiệu quả, lợi nhuận và năng lực cạnh tranh của doanh nghiệp.',
  keywords: 'manufacture,rtls,factory,smart factory, smart manufacture,orbro',
  ogSite: 'Tương lai của hệ thống quản lý hàng tồn kho trong nhà máy sản xuất',
  title: 'Tương lai của hệ thống quản lý hàng tồn kho trong nhà máy sản xuất',
  ogUrl: 'https://orbro.io/vi/blog/nextManufacturing',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDxbC6Lmz5d8iN1v3jEMtSZe3Ob88JgI_jXXAfJ7GZaTrf8KH3DEO1m4HlYFIDS9bFuaJ56cZ_wEcBOXyqi7Rd1uXIPtcB1SZL5Zzp4Zl2tEjAhAsyq98MX-gfwKbsfAr4dO1q5vsbz2K4nTUWHruzU-5hBlcQ1yxNQlsPiYw4RphqkypMB-pwo0G3P-xK2AXu-BK2gkkGECBMSaqNR4kGBEpmdgxTWhwccWsjJ-q7e0HIujysRfM0l0ypLuO4Tq-jlmwITla4reB_nvTWUkbQKvS3L0qLAUKFsKGUijjxU1e2K4uu9c2imXUJIAMcSwzhUuYwW68muAKugSd95IOSWlAtP8ygMwSe62DG3ytNQxSEOVw77XQP8MXzF61yzQn7TttUsTIEbaSPUkfS82CVlcwFZfj6Eu1TGVGPIBtzA5h2Ye0wCkx1uG2j9YWPT4I3onzdUX6_M7mLn--deX_zstjJWguDI_2zuFy31WB_lALFYps0Wm-iD9E_eCocJkE8sKpKvVfLD8uf1wiLAGX6r_6LtzfaGAxI3m3o1IG2MMTTXnMH6y-O3M6aUz3yqjmxF4T92JTEMFPIboDM657wvRyI-U9Qpt97oMe5HnrqwIa08nTpbjCqaT4H7tCiVm3ms4KDzEpQDKEOqlJIuc--1X0qcGvt7mp8YQAErkrY3fX0wyvBJbOjLS9ckhMpZnvQjz3HjWHSYqtQfo0_bre3v0tKk-dRNj8V9lo3VQEG9NSGTAAJWe-TAVQ6WSwGZpY5qS5C39YC5uFkS6CjMs4lFwQaiGWSqkBZu38_UFyvcZqPxFXU6-zwQJXf5P5VvNO9vV9PxIA45viCVrRJ5_N9NHS1KqxQnQf1dbqGmhbVcF9bE4ZQuaZPelOXIlXJTNA1buHW1HlFOWAr7-ptDHQRaOi0XStG1jluCzkkOqa8rmsmVDq54dvkmSTQToTR_iiZz_sHItPoyJrSpwOBsdj0JILyCwzJCON67Fj5ekj3Lp70M-oY5FfJ0h2SGgTIBR-AEW83ZzuSV7LCetAq4DfJJjFWberG95uPpPBTxfxnUDm8UD4tuCyEeqC0-aaP-6R9rJ__4kDk-HhcrkgYQ52rX2eUTWvX_HaBu_czaZ4_7n0W97P0HAXBII94mQ4CI-nyZKtya-i3R4Af6g826lPfcA-BN8mbIh_bvRi3dvrQD6-ikeEvXvtTDzkvqJ4NSW9UpYBoAAMx4u4PEKvDX5M6o10FceVzq_SJtSHC3PQ4LvvKBrdakrFs7tGHjQjUGEyyLWU-hKwZq2ImS95HpI9MTvV8MJCGQGuUcEn4PGilBE_Y8gik5a7EeanF5XYjw_sHHwXZXT3zq03vRnmXVoal3_zVl8fkohp_Ja3JZopz1hKqUtZj6TkyeoF8plJmaHXlNu_Sc2lG7JEeFwlfKdG-ZOhpUk387Q1YuFalokq_NBDxN471dJmii2uBokKcm0aZWHMkJE8JLrb5NF7jyCJawF6fNMUK-yh-OJvWFcNLfXHznai5Bdfx6bV0Uq1Q2FQIHJAhtflvB7IZcFiQJ3H8Ul-rWYyOHnxDTZJ5yt5IbVKmudE_SNi6ASGmkwwg=w2000-h4260',
  ogType: 'website',
  date: '2023-10-16',
  tag1: '#Manufacture',
  tag2: '#RTLS',
  tag3: '#Factory',
  tag4: '#ORBRO',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Các nhà sản xuất đang không ngừng nỗ lực tìm cách cải thiện vận hành nhà máy và quản lý hàng tồn kho. Những nỗ lực này được coi là nhiệm vụ quan trọng nhằm nâng cao hiệu quả, lợi nhuận và năng lực cạnh tranh của doanh nghiệp. Trong những năm gần đây, công nghệ Hệ thống Theo dõi Vị trí Thời gian Thực (RTLS) đang tạo ra một cuộc cách mạng trong quản lý hàng tồn kho tại nhà máy sản xuất, và bài viết này sẽ xem xét cách công nghệ RTLS giúp ích to lớn cho việc quản lý hàng tồn kho tại nhà máy sản xuất.',
      dot: '',
    },
    {
      head: 'RTLS là gì?',
      subHead: '',
      desc: "RTLS là viết tắt của 'Real-Time Location System', có nghĩa là hệ thống theo dõi vị trí thời gian thực. Công nghệ này là một hệ thống cho phép theo dõi vị trí của vật thể hoặc con người trong thời gian thực bằng cách sử dụng các cảm biến và công nghệ truyền thông đa dạng. RTLS tích hợp nhiều công nghệ khác nhau như GPS, RFID, mạng cảm biến, truyền thông không dây để cung cấp cho người dùng thông tin vị trí chính xác và theo thời gian thực.",
      dot: '',
    },
    {
      head: 'Ứng dụng RTLS trong nhà máy sản xuất',
      subHead: '1. Theo dõi và quản lý hàng tồn kho',
      desc: 'RTLS có thể theo dõi vị trí của nguyên vật liệu, linh kiện, bán thành phẩm và thành phẩm trong nhà máy sản xuất theo thời gian thực. Điều này cho phép quản lý hàng tồn kho một cách hiệu quả, giúp các nhà sản xuất dễ dàng tìm thấy lượng hàng cần thiết và giảm thiểu lãng phí. Hơn nữa, việc nắm bắt vị trí và sự di chuyển của hàng tồn kho theo thời gian thực giúp ngăn chặn tình trạng thiếu hụt hoặc dư thừa hàng tồn kho và cắt giảm chi phí logistics.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Tối ưu hóa quy trình sản xuất',
      desc: 'RTLS có thể tối ưu hóa quy trình sản xuất bằng cách theo dõi vị trí của người lao động và thiết bị trên dây chuyền sản xuất. Đây là yếu tố quan trọng để nâng cao năng suất và tuân thủ lịch trình sản xuất. Ngoài ra, các nhà sản xuất có thể phân tích luồng công việc của người lao động và thiết bị để xác định và cải thiện các điểm nghẽn.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Tăng cường an toàn và an ninh',
      desc: 'RTLS đóng vai trò quan trọng trong việc tăng cường an toàn cho người lao động. Bằng cách theo dõi vị trí của người lao động đang làm việc trong các khu vực có nguy cơ cao và phát hiện sớm các tình huống nguy hiểm, RTLS giúp phòng ngừa và đối phó với tai nạn. Hơn nữa, nó đảm bảo an toàn cho thiết bị và hàng tồn kho, đồng thời có thể ngăn chặn trộm cắp.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Tự động hóa và ứng dụng robot',
      desc: 'RTLS có thể tích hợp với các hệ thống robot tự động để quản lý chính xác vị trí làm việc và di chuyển của robot trong nhà máy. Nhờ đó, sự hợp tác giữa robot và con người diễn ra hiệu quả. Robot có thể sử dụng RTLS để thiết lập lộ trình và vị trí làm việc chính xác khi vận chuyển hàng tồn kho hoặc tự động thực hiện các quy trình.',
      dot: '',
    },
    {
      head: 'Tương lai của RTLS',
      subHead: '',
      desc: 'Công nghệ RTLS đang tiếp tục phát triển và tiến bộ, và tương lai của hệ thống quản lý hàng tồn kho trong nhà máy sản xuất được dự đoán sẽ có nhiều đổi mới hơn nữa. Một vài tiềm năng trong tương lai bao gồm:',
      dot: '',
    },
    {
      head: '',
      subHead: '1. Tận dụng mạng 5G',
      desc: 'Khi mạng 5G ngày càng phổ biến, khả năng kết nối và băng thông của RTLS sẽ được cải thiện. Điều này sẽ cho phép truyền tải và xử lý nhiều dữ liệu hơn trong thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Ứng dụng trí tuệ nhân tạo và học máy',
      desc: 'Công nghệ trí tuệ nhân tạo và học máy sẽ được áp dụng để tận dụng dữ liệu RTLS nhằm đưa ra các dự đoán và quyết định chính xác hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Mở rộng hệ sinh thái',
      desc: 'Các công ty RTLS sẽ phát triển và cung cấp các nền tảng có thể tích hợp với các hệ thống nhà máy sản xuất khác, từ đó mở rộng hệ sinh thái nhà máy sản xuất.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Công nghệ RTLS đã mang lại những thay đổi mang tính cách mạng cho hệ thống quản lý hàng tồn kho của nhà máy sản xuất, và tương lai của nó có vẻ ngày càng tươi sáng. Các nhà sản xuất tận dụng công nghệ này sẽ nâng cao hiệu quả và tăng cường khả năng cạnh tranh. Trong khi theo dõi sự phát triển trong tương lai của RTLS, các doanh nghiệp theo đuổi sự đổi mới trong lĩnh vực quản lý hàng tồn kho tại nhà máy sản xuất sẽ gặt hái được nhiều thành công hơn nữa trong tương lai.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: medicalWaste.thumb,
        data: 'medicalWaste',
        link: '/vi/enterprise/medical/waste',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
